import r from "./td-longtail-vue-components190.js";
import i from "./td-longtail-vue-components191.js";
/* empty css                              */
import s from "./td-longtail-vue-components98.js";
const o = {
  name: "OfferConfigurator",
  components: {
    BundleConfigurator: r,
    SingleItemConfigurator: i
  },
  props: {
    focusedItemIndex: {
      type: Number,
      default: void 0
    },
    bundleItems: {
      type: Array,
      default: () => []
    }
  },
  emits: ["select-variant"],
  computed: {
    firstBundleItem() {
      return this.bundleItems[0] || {};
    },
    isBundle() {
      return this.bundleItems.length > 1 || this.firstBundleItem.isMerged;
    }
  }
};
var u = function() {
  var e = this, t = e._self._c;
  return e.isBundle || e.firstBundleItem ? t("div", { staticClass: "offer-configurator" }, [e.isBundle ? t("BundleConfigurator", { attrs: { "focused-item-index": e.focusedItemIndex, "bundle-items": e.bundleItems }, on: { "select-variant": (n) => e.$emit("select-variant", n) } }) : t("SingleItemConfigurator", { attrs: { "bundle-item": e.firstBundleItem }, on: { "select-variant": (n) => e.$emit("select-variant", n) } })], 1) : e._e();
}, a = [], l = /* @__PURE__ */ s(
  o,
  u,
  a,
  !1,
  null,
  null
);
const p = l.exports;
export {
  p as default
};
